import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import React, { FC } from "react";

export const SkeletonFilters: FC = () => {
  return (
    <Box sx={{ display: "flex", gap: "1rem" }}>
      <Skeleton variant="rounded" width={320} height={56} />
      <Skeleton variant="rounded" width={320} height={56} />
    </Box>
  );
};

export const SkeletonClosureSection: FC = () => {
  return <Skeleton variant="rounded" width="100%" height={80} />;
};

export const SkeletonWeeklySchedule: FC = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "0.75rem" }}>
      <Skeleton variant="text" width={160} height={32} />
      {Array.from({ length: 7 }).map((_, i) => (
        <Skeleton key={i} variant="rounded" width="100%" height={64} />
      ))}
    </Box>
  );
};
